import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { HealthAppService } from 'src/app/services/explore-health/health-app.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit, OnDestroy {
  version: string = '';
  private readonly destroy$ = new Subject<void>();

  constructor(private readonly healthAppService: HealthAppService) {}

  ngOnInit(): void {
    this.updateAppVersion();
    this.healthAppService.userSettingsUpdated
      .pipe(takeUntil(this.destroy$))
      .subscribe(this.updateAppVersion.bind(this));
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private updateAppVersion(): void {
    if (this.healthAppService.auth.isAuthenticated()) {
      this.healthAppService.getVersion().subscribe({
        next: (res) => {
          this.version = res?.version;
        },
        error: (error) => {
          console.error('Failed to get app version', error);
        },
      });
    }
  }
}
